import LoadingPage from '@/components/LoadingPage/LoadingPage';
import OrganizationPickerPage from '@/components/OrganizationPickerPage/OrganizationPickerPage';
import { UserOrganization } from '@/modules/Users/domain';
import { useGetCurrentUser } from '@/modules/Users/queries';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';
import { toast } from 'react-toastify';

function DashboardRedirectorPicker({
  organizations,
  onSelect,
}: {
  organizations: UserOrganization[];
  onSelect: (organizationId: number) => void;
}) {
  return (
    <OrganizationPickerPage organizations={organizations} onSelect={onSelect} />
  );
}

export default function DashboardOrganizationRedirector() {
  const { t } = useTranslation();
  const { data: user, isLoading, isError } = useGetCurrentUser();
  const [organizationId, setOrganizationId] = useState<number | undefined>(
    () => {
      const sessionOrganizationId = sessionStorage.getItem('organizationId');
      if (sessionOrganizationId) {
        return +sessionOrganizationId;
      }
    },
  );

  useEffect(() => {
    if (!isLoading && isError) {
      toast.error(t('error.fetch_current_user_data'));
    }
  }, [isError, isLoading, t]);

  if (isLoading) {
    return <LoadingPage />;
  }

  if (organizationId) {
    return <Navigate to={`organization/${organizationId}`} replace />;
  }

  if (user?.organizations && user.organizations.length === 1) {
    return <Navigate to={`organization/${user.organizations[0].id}`} replace />;
  }

  return (
    <DashboardRedirectorPicker
      organizations={user?.organizations ?? []}
      onSelect={setOrganizationId}
    />
  );
}
